"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignedToFieldLogic = void 0;
var assigned_to_fieldtype_1 = require("./assigned-to.fieldtype");
Object.defineProperty(exports, "AssignedToFieldLogic", { enumerable: true, get: function () { return assigned_to_fieldtype_1.AssignedToFieldLogic; } });
